const AdTypesEnum = {
    GRID: "Grid",
    INSTORY1: "InStory1",
    INSTORY2: "InStory2",
    INSTORY3: "InStory3",
    BANNER1: "Banner1",
    BANNER2: "Banner2",
    BANNER3: "Banner3",
};
module.exports = AdTypesEnum;